import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}));

/* Types */
export const GET_LOCATIONS = 'GET_LOCATIONS'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_LOCATIONS:
			return state.set('Get', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getLocations = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getLocations',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {

			const data = response.data

			const dataLocations = new Array()

			if (data.ubicaciones.ubicacionEjercicioFiscal[0].ubicaciones) {

				data.ubicaciones.ubicacionEjercicioFiscal[0].ubicaciones.ubicacion.map((l) => {
					let obj = {
						uniqueId: Utils.getUUID(),
						actividadDesarrolla: l.actividadDesarrolla,
						calle: l.calle,
						ciudad: l.ciudad,
						codigoPostal: l.codigoPostal,
						colonia: l.colonia,
						entreCalle1: l.entreCalle1,
						entreCalle2: l.entreCalle2,
						estado: l.estado,
						id: l.idUbicacion,
						municipio: l.municipio,
						numeroExterior: l.numeroExterior,
						numeroInterior: l.numeroInterior,
						poblacionAtendida: l.poblacionAtendida,
						referencia: l.referencia,
						domicilio: `${l.estado.descripcion}, ${l.municipio.descripcion}, ${l.ciudad.descripcion}, ${l.calle}, ${l.numeroExterior}, ${l.numeroInterior||''}`,
						clasificacion: Number(l.clasificacion) || 1,
					}
					obj.checkSede = obj.clasificacion === 2 ? true : false
					dataLocations.push(obj)
				})
			}

			console.log(dataLocations)

			dispatch(isLoading(false))
			dispatch({ type: GET_LOCATIONS, Obj: {dataLocations: dataLocations} })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setLocations = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setLocations',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const deleteLocations = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/deleteLocations',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Information/Locations.js